import axios from "axios";
import { BASE_URL_API } from "../CONSTANTS";
import {store} from "../redux/store";
 const _http = axios.create();
_http.defaults.baseURL = BASE_URL_API;



//
_http.interceptors.request.use(
    function(config) {
        // Add authorization token to the request headers
        //@ts-ignore
        const authToken =store.getState()?.auth?.user?.token

        config.headers.Authorization = `Bearer ${authToken??""}`;
        return config;
    },
    function(error) {
        // Handle request error
        return Promise.reject(error);
    }
);

export {_http}
